<template>
    
    <div class="layui-fluid">
        <div class="x-anchor">
            <div class="layui-container">
                <div class="layui-row">
                    <a href="#anchor_intro">学校介绍</a>
                    <a href="#anchor_course">课程介绍</a>
                    <a href="#anchor_hotel" v-if="data.data.attributes.hotel && data.data.attributes.hotel.length>0">住宿环境</a>
                    <a href="#anchor_comment">学生评价</a>
                    <a class="anchor_count" href="#anchor_count">费用计算</a>
                    <!-- <div class="layui-col-xs3">学校介绍</div>
                    <div class="layui-col-xs3">课程介绍</div>
                    <div class="layui-col-xs3">住宿环境</div>
                    <div class="layui-col-xs3">图文介绍</div> -->
                </div>
            </div>
        </div>
        <div class="layui-container">
            <div class="layui-row x-py16">
                <span id="bread" lay-separator=">">
                    <a :href="myUtils.getFlugCity(data.data.attributes.city.data)">{{
                        data.data.attributes.city.data?.attributes?.name }}地区语言学校</a>
                    <a><cite>{{ data.data.attributes.name }}</cite></a>
                </span>
            </div>
            <SchoolTopvideo :data="data" />
            <div class="layui-row x-head">
                <div class="layui-col-xs12 layui-col-sm12 layui-col-lg9 lbox">
                    <div class="box x-bg-white">
                        <SchoolSlogn :data="data" />
                        <hr class="x-my32" />
                        <SchoolCourse id="anchor_course" :data="data" />
                        <SchoolHotel id="anchor_hotel" :data="data"/>
                        <p class="x-text-center x-mb32"><a :href="`/${myUtils.getCurrentCountry()}-signup?${myUtils.objectToQueryString({id:data.data.id,name:data.data.attributes.name})}`" class="x-submit">一价全含最省心，点我锁定优惠价格</a></p>
                        <!-- <div v-html="htmlContent"></div> -->
                        <SchoolMap ref="refMap" class="x-md" :data="data" />
                        <div id="anchor_intro" ref="refContainer" class="x-md" v-html="htmlContent_start"></div>
                        <SchoolProvide ref="refProvide" :data="data" />
                        <SchoolCert ref="refCert" :data="data" />
                        <SchoolRate ref="refRate" :data="data" />
                        <!-- <div class="x-md" v-html="htmlContent_end"></div> -->
                        <SchoolComment id="anchor_comment" :data="data" />
                        <CoursesQA class="x-md-topborder" />
                    </div>
                </div>
                <div class="layui-col-xs12 layui-col-sm12 layui-col-lg3 rbox">
                    <div class="">
                        <CoursesCount id="anchor_count" :data="data.data" />
                        <CoursesOther />
                        <CoursesHot />
                        <CoursesArticle />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.box {
    padding: 24px 0px;
    border-radius: 16px;
    margin-bottom: 24px;
}


@media screen and (min-width: 1200px),
screen and (min-width: 1400px) {
    .box {
        padding-left: 32px;
        padding-right: 32px;
    }

    /* 只在大屏展示的样式 */
    .lbox {
        width: 868px;
        margin-right: 32px;
    }

    .rbox {
        width: 300px;
    }
}
</style>


<script setup>
import qs from 'qs';
const htmlContent_start = ref("");
const htmlContent_end = ref("");


const { id } = useRoute().params;
const sId = id.split('-')[0];
console.log('useRout.params', useRoute().params);
const query = qs.stringify({
    publicationState: "preview",
    populate: {
        feature: '*',
        courses: {
            populate: '*'
        },
        rate: '*',
        pictures: {
            fields: ['width', 'hash', 'ext']
        },
        logo: {
            fields: ['width', 'hash', 'ext']
        },
        comments: {
            populate: {
                avatar: {
                    fields: ['width', 'hash', 'ext']
                }
            }
        },
        map : {
            fields: ['width', 'hash', 'ext']
        },
        city: {
            fields: ['name']
        },
        school_features: {
            fields: ['name']
        },
        school_certifications: {
            fields: ['desc'],
            populate : {
                logo : {
                    fields : ['width', 'hash', 'ext']
                }
            }
        },
        hotel : {
            populate: '*'
        },
        hotel_photos : {
            populate : {
                fields : ['type'],
                photos : {
                    fields : ['width', 'hash', 'ext']
                }
            }
        },
        airport_transfer : {
            populate : '*'
        }
    },
})
const url = '/api/fw/schools/' + sId + '?' + query;
console.log('url', url);
// const { data } = await useFetch('/api/fw/schools/' + id + '?populate[courses][populate]=*&populate[rate]=*&populate[pictures]=*');
const { data } = await useFetch(url);



function splitSecondDoubleHash(str) {
    // const regex = /(^|[^#])(##)([^#]|$)[^\#]*?(^|[^#])(##)([^#]|$)/g;
    const regex = /^([^<]*)(?:<h[1|2]>.*?){2}/;
    // const regex= /.*(?<h1>[^<]*图文详解<\/h1>)/g
    const matches = str.match(regex);
    console.log('matches', matches);
    if (matches && matches[0]) {
        const secondDoubleHashIndex = matches[0].length;
        return [str.slice(0, secondDoubleHashIndex), str.slice(secondDoubleHashIndex)];
    } else {
        return [str];
    }
}
const altImg = data.value.data.attributes.name + '语言学校的介绍照片';
const details = myUtils.resestHttp(data.value.data.attributes.detail || "").replace(/alt="[^"]*"/g, `alt="${altImg}"`);;
// const aDetails = splitSecondDoubleHash(details);
// //srcset会自己判断
// htmlContent_start.value = aDetails?.[0];
// htmlContent_end.value = aDetails?.[1];
const sDetails = myUtils.resetH1(details); 
htmlContent_start.value = sDetails;

const aInsertDom = [];
let mapDom = null;
const getDomHasTuwen = (aDom) => {
    let dom;
    for (let i = 0; i < (aDom || []).length; i++) {
        dom = aDom[i];
        // console.log('childNode:', dom, dom.nodeType, dom.tagName)
        if (dom.nodeType !== Node.ELEMENT_NODE) {
            continue;
        }
        const headingText = dom.textContent || dom.innerText;
        if (dom.tagName == "H1" || dom.tagName == "H2") {
            if (headingText.includes('图文详解')) {
                aInsertDom.push[aDom[i]]
                break;
            }
            if (headingText.includes('课外活动')) {
                aInsertDom.unshift(aDom[i]);
                break;
            }
        }
        if (headingText.includes('学校地址') || headingText.includes('学校位置')) {
            mapDom = dom;
        }
    }
    console.log('getDomHasTuwen', aInsertDom.length, mapDom)
}
const refProvide = ref(null);
const refRate = ref(null);
const refContainer = ref(null);
const refMap = ref(null);
const refCert = ref(null);
onMounted(() => {
    nextTick(() => {
        document.getElementById("bread").classList.add('layui-breadcrumb');
        layui.element.render('breadcrumb', "#bread");

        const dProvide = refProvide.value;
        const dRate = refRate.value;
        const dCert = refCert.value;
        const dContainer = refContainer.value;
        const dMap = refMap.value;
        if (dContainer) {
            getDomHasTuwen(dContainer.childNodes);
            // getDomHasTuwen(dContainer.getElementsByTagName('h1'));
            // getDomHasTuwen(dContainer.getElementsByTagName('h2'))
            if (aInsertDom.length > 0) {
                const dom = aInsertDom[0];
                console.log(dom, dContainer, dProvide.$el, dRate.$el)
                dom.parentNode.insertBefore(dProvide.$el, dom);
                dom.parentNode.insertBefore(dRate.$el, dom);
                dom.parentNode.insertBefore(dCert.$el, dom);
            }
            if (mapDom) {
                mapDom.parentNode.insertBefore(dMap.$el, mapDom.nextSibling);
            }
        }
    });
    // 将sourceDiv的内容移动到targetDiv

    //禁用鼠标右键
    document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
    });


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
});


useSeoMeta({
    title :  `${data.value.data.attributes.name}语言学校的学校介绍、申请条件及费用 - ${myUtils.getCurrentCountryName()}游学 - 小鸥游学`,
    description :`我们是${myUtils.getCurrentCountryName() }${data.value.data.attributes.name}语言学校官方合作机构，提供${data.value.data.attributes.name}学校1周-3个月及一年以上的课程代报名，签证服务，帮助安排住宿，接送机，在${myUtils.getCurrentCountryName()}提供的地接及紧急联络人。帮助您安全无忧的体验在${data.value.data.attributes.name}的学习生活`,
    keywords : myUtils.getSeoKeywords()
})

</script>


